let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8rhZ2")).then(() => parcelRequire('gEdc8'));